import {has} from 'utils/features';
import {bannerAd, singleBottomMPUProps, topMPUProps} from "../Common/components/GptProperties";

const leaderboardAd = {
  view: 'home-page'
};

const saturdayMorningLayout = [
  {
    component: "MoreNews",
    desktopColumn: "left",
    desktopOrder: 1,
    handheldOrder: 1
  },
  {
    component: "AdvertWrapper",
    props: {
      ocSlot: ["homepage", "leaderboard"],
      additionalProperties: {
        view: "home-page"
      }
    },
    desktopColumn: "left",
    desktopOrder: 2,
    handheldOrder: 2
  },
  {
    component: "RacingTips",
    props: {
      plainTitle: false
    },
    desktopColumn: "right",
    desktopOrder: 2,
    handheldOrder: 5
  },
  {
    component: "GooglePublisherTag",
    props: topMPUProps,
    desktopColumn: "right",
    desktopOrder: 4,
    handheldOrder: false
  },
  {
    component: "MostReadAll",
    desktopColumn: "right",
    desktopOrder: 5,
    handheldOrder: 3
  },
  {
    component: "HorseRacingNextRaceOff",
    props: {
      plainTitle: true
    },
    desktopColumn: "right",
    desktopOrder: 7,
    handheldOrder: 6
  },
  {
    component: "AdvertWrapper",
    props: {
      ocSlot: ["racing", "leaderboard"],
      additionalProperties: {
        view: "home-page"
      }
    },
    desktopOrder: false,
    handheldOrder: 7
  },
  {
    component: "FootballTips",
    props: {
      plainTitle: true
    },
    desktopColumn: "right",
    desktopOrder: 9,
    handheldOrder: 9
  },
  {
    component: "AdvertWrapper",
    props: {
      ocSlot: ["football", "leaderboard"],
      additionalProperties: {
        view: "home-page"
      }
    },
    desktopOrder: false,
    handheldOrder: 10
  },
  {
    component: "HomeColumnists",
    desktopColumn: "left",
    desktopOrder: 4,
    handheldOrder: 12
  },
  {
    component: "GooglePublisherTag",
    props: {
      adUnitPath: '/67970281/display_thirdparty_gb/sporting_life_responsive/homepage/Bottom_MPU',
      type: "bottomMPU"
    },
    desktopColumn: "right",
    desktopOrder: 10,
    handheldOrder: false
  },
  {
    component: "AdvertWrapper",
    props: {
      ocSlot: ["homepage", "mpu"],
      additionalProperties: {
        view: "home-page"
      }
    },
    desktopColumn: "right",
    desktopOrder: 9,
    handheldOrder: false
  },
  {
    component: "GooglePublisherTag",
    props: singleBottomMPUProps,
    desktopColumn: "right",
    desktopOrder: false,
    handheldOrder: 13
  }
];

if (has('insider-benefits')) {
  saturdayMorningLayout.splice(3, 0, {
    component: "InsiderMpu",
    props: {
    },
    desktopColumn: "right",
    desktopOrder: 3,
    handheldOrder: 6,
    loggedInDisplay: false
  });
}

function pickHomepageLayout() {
  return saturdayMorningLayout;
}

const homePageComponents = layout => ({
  bannerAd: bannerAd,
  leaderboardAd,
  components: pickHomepageLayout(layout)
});

export default {
  '/': layout => homePageComponents(layout)
}



// WEBPACK FOOTER //
// ./modules/Home/layouts.js